import React from "react";

const Footer = () => {
  return (
    <footer className="bg-primary text-white p-2 ">
      <div className="flex flex-1 mx-auto justify-center">
        &copy; Todos los derechos reservados - {new Date().getFullYear()}
      </div>
    </footer>
  );
};

export default Footer;
